<template>
  <div id="filter-wrap" class="flex flex-wrap py-4 ">
    <div class="md:w-6/12 w-full justify-start flex flex-wrap items-center ">
      <div class="table__search-input-wrapper opacity-75">
        <span class="pr-2 opacity-50"><search-icon /> </span>
        <input type="text" class="table__search-input" placeholder="Search..." v-model="searchString" />
        <img @click="openFilterModal" class="cursor-pointer" src="@/assets/images/icons/search.svg"
          alt="search icon" />
      </div>
    </div>
    <div class="flex w-[50%] ">
      <div v-if="interval == 'custom'" class="flex justify-end w-full px-4 pt-0 ">
        <div class="date-picker flex items-center justify-center">
          <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />
          <span class="pr-2 opacity-50"> to </span>
          <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
        </div>
      </div>
      <div >
        <el-dropdown trigger="click" class="h-full w_semi">
          <div class="drp-content">
            <span>
              <img src="../../../../views/3pl/BillingandCollection/icons/CalendarIcon.svg" />
              <abbr class="vrt_line"></abbr>
              <span class="inline-block whitespace-nowrap">{{ filterTitle }}</span>
            </span>
            <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <button @click="setFilterType('today', 'Today')">Today</button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button @click="setFilterType('week', 'This Week')">This week</button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button @click="setFilterType('month', 'This Month')">This month</button>
            </el-dropdown-item>

            <el-dropdown-item>
              <button @click="setFilterType('year', 'This Year')">This year</button>
            </el-dropdown-item>
            <el-dropdown-item>
              <button @click="setFilterType('all', 'All time')">All time</button>
            </el-dropdown-item>
            <el-dropdown-item>
              <button @click="setFilterType('custom', 'Custom')">Custom</button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
   
    <ActiveSearchFilter @appliedRef="appliedReference" :show-modal="showFilterModal"
      @close-modal="showFilterModal = false" :loading="loading" :bookings="bookings" :transactions="transactions"  />

  </div>
</template>

<script>
import ArrowDownBlackIcon from "@/components/UI/svgs/ArrowDownBlackIcon.vue";
import ActiveSearchFilter from "../modals/ActiveSearchFilter.vue";
import debounce from "@/utilities/debounce";
import moment from 'moment';


export default {
  props: ["bookings", "transactions"],
  components: {
    ActiveSearchFilter,
    ArrowDownBlackIcon,
  },
  data() {
    return {
      interval: "month",
      filterTitle: 'This Month',
      showFilterModal: false,
      startDate: "",
      endDate: "",
      searchString: "",
    };
  },
  computed: {
    payload() {
      return {
        startDate: "month"
      };
    },

    sortProps() {
      return {
        // searchTerm: this.searchString,
        interval: this.interval,
        startDate:  this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),        
        endDate:  this.endDate ? moment(this.endDate).format("YYYY-MM-DD"): moment().format("YYYY-MM-DD"), 
      };
    },
  },
 
  watch: {
    "sortProps": debounce(function () {
      if (this.interval == 'custom' && this.startDate && this.endDate && (this.endDate > this.startDate)) {               
        this.$emit("setQueryparams", this.sortProps);
        return
        }
    }, 500),

     searchString: debounce(function (val) {
       this.$emit("setSearchTerm", val); 
    }, 500),
  },

  methods: {
    openFilterModal() {
      this.searchString = ''
      this.showFilterModal = !this.showFilterModal
    },
  
    appliedReference(filteredVal) {
      this.searchString = filteredVal
    },
    setFilterType(val, title) {
      this.interval = null
      this.interval = val
      this.filterTitle = title
      this.payload.startDate = val
      
      if (val != "custom") {
        this.$emit("filterProps", this.payload.startDate)
        this.startDate = ""
        this.endDate = ""
      }
    },

  },
};
</script>

<style lang="scss" scoped>
#filter-wrap{
  flex-wrap: wrap; 
}
#filter-wrap>:nth-child(2){
  display: flex;
  justify-content: end; 
}
.w_semi {
  @apply w-[200px] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}

.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}
</style>